import React, { useState } from "react";
import { motion } from "framer-motion";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import Phone from "../components/vectors/phone";
import Email from "../components/vectors/email";
import WhatsApp from "../components/vectors/whatsapp";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import Layout from "../components/layout";
import PageHeading from "../components/pageheading";
import "../styles/global.scss";


export default function Quote_Request({ data }) {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    collectionAddress: "",
    deliveryAddress: "",
    descriptionOfItems: "",
    otherDetails: "",
  });
  //collection 'when' state
  const [whenSelection, setWhenSelection] = useState("on");
  // collection date picker
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState('');

  const handleSelectionChange = (e) => {
    setWhenSelection(e.target.value);
  };

  //delivery 'when' state
  const [whenDeliverySelection, setWhenDeliverySelection] = useState("on");
  //delivery date picker
  const [startDeliveryDate, setStartDeliveryDate] = useState(new Date());
  const [endDeliveryDate, setEndDeliveryDate] = useState('');

  const handleDeliverySelectionChange = (e) =>
    setWhenDeliverySelection(e.target.value);

  //vehicle selection
  const [vehicleSelection, setVehicleSelection] = useState(
    "Please select required vehicle"
  );

  const handleVehicleSelectionChange = (e) =>
    setVehicleSelection(e.target.value);

  const handleChange = (e) =>
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });

  const {
    name,
    email,
    phone,
    collection_address,
    delivery_address,
    description_of_items,
    other_details,
  } = formState;

  return (
    <Layout>
      <div className="quote-page">
        <PageHeading heading="Quote Request" />

        <div className="main-content">
          <motion.div className="img-wrapper"
          initial={{x:-1300}}
          animate={{x:0}}
          transition={{delay: 0.3}}
          >
            <Img
              className="moving-van"
              fluid={data.MWB.childImageSharp.fluid}
              alt="smiling warehouse worker"
            />
            
          </motion.div>
          <motion.div className="text-wrapper"
          initial={{opacity:0}}
          animate={{opacity:1}}
          transition={{delay:0.65}}
          >
            <h2>Fantastic service at a fantastic price!</h2>
            <p>
              If you’re looking for a great price for a great service you’re at
              the right place. You can request a quote using one of the methods
              below, and a friendly adviser will be in touch shortly.
            </p>
          </motion.div>
        </div>

        <motion.div
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        transition={{delay:0.65}}
        className="contact-methods">
          <div className="contact-method">
            <Phone className="method-img" />
            <p>Telephone</p>
            <p>0333 4040 224</p>
          </div>
          <div className="contact-method">
            <a href="mailto:contact@haslamlogistics.co.uk">
              <Email className="method-img" />
            </a>
            <p>Email</p>
            <a href="mailto:contact@haslamlogistics.co.uk">
              Contact@HaslamLogistics.co.uk
            </a>
          </div>
          <div className="contact-method">
            <WhatsApp className="method-img" />
            <p>WhatsApp Business</p>
            <p>07789 420011</p>
          </div>
        </motion.div>

        <div className="form-wrapper">
          <form
            data-netlify='true'
            netlify-honeypot
            action="/success"
            method="post"
            name="Quote-Request-Form"
          >
            <h4>Quote Request Form</h4>
            <div>
              <p className="required-notice">
                Fields marked with '<span>*</span>' are required
              </p>

              <input
                type="hidden"
                name="form-name"
                value="Quote-Request-Form"
              />
              <label htmlFor="name">
                Name of business or individual<span>*</span>
              </label>
              <input
                type="text"
                name="name"
                onChange={handleChange}
                value={name}
                required
              />

              <label htmlFor="email">
                Email address<span>*</span>
              </label>
              <input
                type="email"
                name="email"
                onChange={handleChange}
                value={email}
                required
              />

              <label htmlFor="phone">
                Phone<span>*</span>
              </label>
              <input
                type="tel"
                name="phone"
                onChange={handleChange}
                value={phone}
                required
              />
              <hr />
              <div className="collection-time-selection">
                <p className="form-section-label">Collection Details</p>

                <label htmlFor="when">
                  When<span>*</span>
                </label>

                <select
                  name="when"
                  onChange={handleSelectionChange}
                  value={whenSelection}
                >
                  <option value="on">on</option>
                  <option value="between">between</option>
                  <option value="before">before</option>
                </select>

                <label htmlFor="start_collection_date">
                  {whenSelection === "between" ? "after" : "Date and time"}
                </label>

                <DatePicker
                  required
                  name="start_collection_date"
                  selected={startDate}
                  minDate={new Date()}
                  onChange={(date) => setStartDate(date)}
                  showTimeSelect
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="dd/MM/yyyy h:mm aa"
                />

                <input type="hidden" value={endDate} name='second_collection_date'/>

                {whenSelection === "between" ? (
                  <>
                    <label htmlFor="second_collection_date">and before</label>
                    <DatePicker
                      required
                      name="second_collection_date"
                      selected={endDate}
                      minDate={new Date()}
                      onChange={(date) => setEndDate(date)}
                      showTimeSelect
                      timeIntervals={15}
                      timeCaption="time"
                      dateFormat="dd/MM/yyyy h:mm aa"
                    />
                  </>
                ) : null}
              </div>

              <label htmlFor="collection_address">Collection Address</label>
              <textarea
                name="collection_address"
                value={collection_address}
                onChange={handleChange}
              ></textarea>
              <hr />

              <div className="delivery-time-selection">
                <p className="form-section-label">Delivery Details</p>

                <label htmlFor="when_delivery">When</label>

                <select
                  name="when_delivery"
                  onChange={handleDeliverySelectionChange}
                  value={whenDeliverySelection}
                >
                  <option value="on">on</option>
                  <option value="between">between</option>
                  <option value="before">before</option>
                </select>

                <label htmlFor="start_delivery_date">
                  {whenDeliverySelection === "between"
                    ? "after"
                    : "Date and time"}
                </label>

                <DatePicker
                  name="start_delivery_date"
                  selected={startDeliveryDate}
                  minDate={new Date()}
                  onChange={(date) => setStartDeliveryDate(date)}
                  showTimeSelect
                  timeIntervals={15}
                  timeCaption="time"
                  dateFormat="dd/MM/yyyy h:mm aa"
                />

                <input type="hidden" name="second_delivery_date" value={endDeliveryDate}/>

                {whenDeliverySelection === "between" ? (
                  <>
                    <label htmlFor="second_delivery_date">and before</label>
                    <DatePicker
                      name="second_delivery_date"
                      selected={endDeliveryDate}
                      minDate={new Date()}
                      onChange={(date) => setEndDeliveryDate(date)}
                      showTimeSelect
                      timeIntervals={15}
                      timeCaption="time"
                      dateFormat="dd/MM/yyyy h:mm aa"
                    />
                  </>
                ) : null}
              </div>

              <label htmlFor="delivery_address">Delivery Address</label>
              <textarea
                name="delivery_address"
                value={delivery_address}
                onChange={handleChange}
              ></textarea>
              <label htmlFor="description">
                Description of items to be delivered
              </label>
              <input
                placeholder="Enter a brief description of items"
                type="text"
                name="description_of_items"
                value={description_of_items}
                onChange={handleChange}
              />

              <label
                className="vehicle-selection-label"
                htmlFor="vehicle_required"
              >
                Vehicle Required
              </label>
              <select
                id="vehicle-selection"
                name="vehicle_required"
                value={vehicleSelection}
                onChange={handleVehicleSelectionChange}
              >
                <option value="Please select required vehicle">
                  Please select required vehicle
                </option>
                <option value="I'm unsure, please advise!">
                  I'm unsure, please advise!
                </option>
                <option value="Motorbike">Motorbike</option>
                <option value="Car">Car</option>
                <option value="Small Courier Van">Small Courier Van</option>
                <option value="Medium Wheelbase Van">
                  Medium Wheelbase Van
                </option>
                <option value="Long Wheelbase Van">Long Wheelbase Van</option>
                <option value="Extra Long Wheelbase van">
                  Extra Long Wheelbase van
                </option>
                <option value="Flat Bed Van Courier">
                  Flat Bed Van Courier
                </option>
                <option value="Luton Van">Luton Van</option>
                <option value="Luton Van + tail lift">
                  Luton Van + tail lift
                </option>
                <option value="Luton Van + curtain side">
                  Luton Van + curtain side
                </option>
                <option value="Luton Van + curtain side + tail lift">
                  Luton Van + curtain side + tail lift
                </option>
                <option value="7.5 tonne Lorry">7.5 tonne Lorry</option>
                <option value="12 Tonne Lorry">12 Tonne Lorry</option>
                <option value="18 tonne Lorry">18 tonne Lorry</option>
                <option value="26 tonne Lorry">26 tonne Lorry</option>
                <option value="Caravan/Trailer Towing">
                  Caravan/Trailer Towing
                </option>
                <option value="Animal Transport">Animal Transport</option>
              </select>

              <label htmlFor="other_details">
                Other details / special requests
              </label>
              <input
                placeholder="e.g. require temperature controlled vehicle"
                type="text"
                name="other_details"
                value={other_details}
                onChange={handleChange}
              />

              <button className="submit" type="submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
}

//graphql query for MWB van img

export const query = graphql`
  query {
    MWB: file(relativePath: { eq: "vehicle images/MWB.png" }) {
      childImageSharp {
        fluid(maxWidth: 900) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`;

